<script lang="ts">
	import { SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/splide/dist/css/splide.min.css';
	import __ from '$lib/stores/TranslationStore';
	import { lazyLoad } from '$lib/actions/lazyLoad';

	export let title: string;
	export let description: string;
	export let image: string;
</script>

<SplideSlide>
	<div class="mt-12 flex flex-col justify-center gap-4 lg:flex-row">
		<img
			use:lazyLoad={image}
			alt="Serviço 100% gratuito"
			class="mx-auto h-[240px] w-[250px] object-contain"
			loading="lazy"
		/>
		<div class="mx-auto max-w-sm px-10 pt-10 text-center lg:pt-0 lg:text-left">
			<h4 class="text-4xl text-primary lg:text-5xl">{title}</h4>
			<p class="mt-7 h-44 text-lg text-dark md:h-80 lg:text-xl">{description}</p>
		</div>
	</div>
</SplideSlide>
